import React from "react";

/* Claude-style soft-tinted pills (Won is a deeper sage, not solid filled). */
const PALETTE = {
  active:    { bg: "#E8EFE9", fg: "#2F4F3E", dot: "#3F6E55" },
  submitted: { bg: "#E5EEF7", fg: "#1F4E83", dot: "#2D6CB6" },
  won:       { bg: "#D7E5DB", fg: "#1F3A2C", dot: "#2F4F3E" },
  lost:      { bg: "#ECE9E1", fg: "#6B6B6B", dot: "#A0A0A0" },
  draft:     { bg: "#FEF3E2", fg: "#B45309", dot: "#D97706" },
  archived:  { bg: "#F0EEE6", fg: "#7A7363", dot: "#A89F87" },
  void:      { bg: "#F4E6E4", fg: "#9B3A37", dot: "#B91C1C" }
};

const LABEL = {
  active: "Active",
  submitted: "Submitted",
  won: "Won",
  lost: "Lost",
  draft: "Draft",
  archived: "Archived",
  void: "Void"
};

export default function StatusPill({ status = "active", size = "md" }) {
  const p = PALETTE[status] || PALETTE.active;
  const isSm = size === "sm";
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-md"
      style={{
        background: p.bg,
        color: p.fg,
        padding: isSm ? "2px 7px 2px 6px" : "3px 8px 3px 7px",
        fontSize: isSm ? 9.5 : 10.5,
        fontWeight: 600,
        letterSpacing: "0.05em",
        textTransform: "uppercase"
      }}
    >
      <span
        aria-hidden="true"
        className="inline-block rounded-full"
        style={{
          width: isSm ? 5 : 6,
          height: isSm ? 5 : 6,
          background: p.dot
        }}
      />
      {LABEL[status]}
    </span>
  );
}
